import { Injectable } from '@angular/core';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
import {Observable, from, ObservedValueOf} from 'rxjs';
import firebase from "firebase/compat";
import HttpsCallableResult = firebase.functions.HttpsCallableResult;
import {map} from "rxjs/operators";

interface WhatsAppMessage {
  to: string;
  body?: string;  // Add body for custom messages
  templateVariables?: Record<string, string>;
  contentSid?: string;
  isTemplate?: boolean;  // Flag to determine if it's a template message
}


interface WhatsAppResponse {
  success: boolean;
  messageId?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class WhatsAppService {
  private functions = getFunctions();

  // @ts-ignore
  /**
   * Sends a WhatsApp message using a template
   */
  // @ts-ignore
  sendTemplateMessage(params: WhatsAppMessage): Observable<ObservedValueOf<Promise<HttpsCallableResult<WhatsAppResponse>>>> {
    const sendWhatsApp = httpsCallable<WhatsAppMessage, WhatsAppResponse>(
      this.functions,
      'sendWhatsAppMessage'
    );
    return from(sendWhatsApp(params));
  }

  /**
   * Sends a simple WhatsApp text message
   */
  sendTextMessage(to: string, body: string): Observable<ObservedValueOf<Promise<firebase.functions.HttpsCallableResult>>> {
    return this.sendTemplateMessage({
      to,
      contentSid: undefined,
      templateVariables: { body }
    });
  }
  sendCustomMessage(to: string, body: string): Observable<WhatsAppResponse> {
    const functions = getFunctions();
    const sendMessage = httpsCallable<WhatsAppMessage, WhatsAppResponse>(
      functions,
      'sendWhatsAppMessage'
    );

    return from(sendMessage({
      to,
      body,
      isTemplate: false
    })).pipe(
      map(result => result.data)
    );
  }

}
